// =============================================================================
// legal.js
// -----------------------------------------------------------------------------
// Anzeige-Stand der AGB und der Datenschutzerklaerung im Frontend. Der
// verbindliche, gespeicherte Stand kommt vom Backend (app/utils/legalVersions.js)
// und wird ueber den Selbstbucher-Katalog ("legal") mitgeliefert. Dieser Wert
// hier dient nur der Anzeige auf den Rechtstexten, falls der Katalog nicht
// geladen ist.
// =============================================================================

export const LEGAL_STAND_ANZEIGE = "11.10.2026";
// Datenschutzerklaerung separat: 31.10.2026 um Kartenbild/KI (Punkt 2b, 5a) ergaenzt.
export const LEGAL_PRIVACY_STAND_ANZEIGE = "31.10.2026";

/** Wandelt JJJJ-MM-TT (Backend) in TT.MM.JJJJ (Anzeige) um. */
export function formatLegalVersion(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
  if (!match) return LEGAL_STAND_ANZEIGE;
  return `${match[3]}.${match[2]}.${match[1]}`;
}
